/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './home-links.scss';

/*@ngInject*/
export default function HomeLinksController($scope, menu) {
    var vm = this;

    vm.$onInit = function () {
        vm.model = menu.getHomeSections();
    };
}



// WEBPACK FOOTER //
// ./src/app/home/home-links.controller.js